import enUS from "antd/lib/locale/en_US";
import esES from "antd/lib/locale/es_ES";
import trTR from "antd/lib/locale/tr_TR";

import { englishSource } from "./en";
import { spanishSource } from "./es";
import { turkishSource } from "./tr";

export type CurrentLanguageSourceType = typeof languageSources[keyof typeof languageSources];

export type LanguageCode = keyof typeof languageCodeToAntDCodeMap;

export const languageSources = {
  en: englishSource,
  es: spanishSource,
  tr: turkishSource,
};

export const languageCodeToAntDCodeMap = {
  en: enUS,
  es: esES,
  tr: trTR,
};

export const displayLanguageCodesMap: { [code in LanguageCode]: string } = {
  en: "ENG",
  es: "ESP",
  tr: "TUR",
};

// Flipped the object to avoid uneeded computation, we'll rarely update these.
export const displayLanguageToInternalCodeMap: { [displayCode: string]: LanguageCode } = {
  ENG: "en",
  ESP: "es",
  TUR: "tr",
};
